export function getPic(accessToken){
    // Fetch the user's profile picture using Microsoft Graph API
    fetch('https://graph.microsoft.com/v1.0/me/photo/$value', {
        headers: {
            'Authorization': `Bearer ${accessToken}`
        }
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.blob();
    })
    .then(imageBlob => {
        // Create an object URL for the fetched image
        const imageUrl = URL.createObjectURL(imageBlob);
        // Set the image source to display the user's profile picture
        document.getElementById('profilePicture').src = imageUrl;
    })
    .catch(error => {
        console.error('Error fetching the profile picture:', error);
    });
}
